import { render } from "./BeneficiarySearch.vue?vue&type=template&id=c66180d0&scoped=true"
import script from "./BeneficiarySearch.vue?vue&type=script&lang=js"
export * from "./BeneficiarySearch.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=c66180d0&scoped=true&lang=css&external"
import "./BeneficiarySearch.vue?vue&type=style&index=1&id=c66180d0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c66180d0"]])

export default __exports__